import { Box, Button, Heading, Text, useMediaQuery } from "@chakra-ui/react";
import { Center, Flex } from "@chakra-ui/layout";
import Logo from "../components/Logo";
import { NavLink } from "react-router-dom";


function RoutingErrorPage() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  
  return (
    <Flex id="error-page">
      { !isSmallDevice && <Box display={{ base: "none", lg: "block" }} w='50vw' backgroundColor="brand.700"></Box> }
      <Center w={ !isSmallDevice ? '50vw' : '100vw'}>
        <Flex
          direction="column"
          alignItems="left"
          justifyContent="center"
          h="100vh"
          w="100%"
          px={{ base: "44px", md: "144px" }}
        >
          <Flex direction="column" alignItems="center">
            <Logo />
            <Heading
              fontWeight={600}
              fontSize="32px"
              lineHeight="48px"
              color="gray.900"
              whiteSpace={"nowrap"}
            >
              Oops !
            </Heading>
            <Text
              fontWeight={400}
              fontSize="20px"
              lineHeight="30px"
              color="gray.600"
              textAlign="center"
              display={{ base: "none", sm: "block" }}
            >
              Une erreur inattendue s'est produite.
            </Text>
          </Flex>

          <Center my="24px">
            <Button variant="link" color="brand.700">
              <NavLink to="/dashboard">Retourner au menu principal</NavLink>
            </Button>
          </Center>
        </Flex>
      </Center>
    </Flex>
  );
}

export default RoutingErrorPage;
